export const isNumber = (x: any) => typeof x === 'number' && !Number.isNaN(x);